/* RESPONSIBLE TEAM: team-tickets-1 */
import { ParentAction } from './action';

export default class CreateLinkedTicket extends ParentAction {
  id = 'create-linked-ticket';
  icon = 'ticket' as const;
  paneComponent = 'inbox2/command-k/create-linked-ticket/pane';
}
